import React from "react";
import {Calendar, Cast, Cpu, Filter, GitCommit, Loader, Send, ThumbsUp,} from "react-feather";
import img_lances from "../../imagens/mob_lances.png";
import {CollCard, CollImg, ContainerBody, Wrapper} from "../styleMobile";
import {CardFeatures} from "../Components/CardFeatures";
import {CardHearder} from "../Components/CardHearde";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const Disputa = ({id}) => {
    return (
        <ContainerBody id={id} background={'#9F905C'}>
            <Wrapper>
                <CardHearder
                    icon={<Send size={'40px'}/>}
                    titulo={'LANCES'}
                    texto={'Importe sua planilha, selecione seus documentos de habilitação e anexos da proposta e automatize o envio pro portal do comprasnet. Gerencie as propostas enviadas alterando, incluindo ou excluindo a qualquer momento.\n'}
                />

                <CollImg>
                    <div>
                        <img
                            src={img_lances}
                            height={"auto"}
                            width={"100%"}
                            alt={"logo wavecode"}
                        />
                    </div>
                </CollImg>

                <CollCard>
                    <CardFeatures icon={<Loader/>} texto={"ATUALIZADO"}/>
                    <CardFeatures icon={<GitCommit/>} texto={"INTEGRAÇÃO"}/>
                    <CardFeatures icon={<Cpu/>} texto={"ALTA PERFORMANCE"}/>
                    <CardFeatures icon={<ThumbsUp/>} texto={"SIMPLICIDADE E FACILIDADE"}/>
                </CollCard>

            </Wrapper>
        </ContainerBody>
    )
};
